<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="3" :sm="24">
              <a-form-item label="剧集" prop="serialNumber">
                <a-input-number :min="1" v-model="queryParam.serialNumber" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="短剧名称" prop="videoId">
                <!--                <a-input v-model="queryParam.videoId" placeholder="请输入短剧id" allow-clear/>-->
                <a-tree-select
                  v-model="queryParam.videoId"
                  show-search
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  placeholder="请选择短剧"
                  allow-clear
                  tree-default-expand-all
                  showSearch
                  treeNodeFilterProp="title"
                >
                  <a-tree-select-node :value="item.id" :key="item.id" :title="item.videoName" v-for="(item,index) in listAll">
                  </a-tree-select-node>
                </a-tree-select>
              </a-form-item>
            </a-col>


            <template v-if="advanced">
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="剧集id" prop="gatherId">-->
<!--                  <a-input v-model="queryParam.gatherId" placeholder="请输入剧集id" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="花费金额" prop="price">-->
<!--                  <a-input v-model="queryParam.price" placeholder="请输入花费金额" allow-clear />-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 5 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations" style="display: flex; justify-content: flex-end;">
<!--        <a-space :wrap="true">-->
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:buy/video:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:buy/video:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:buy/video:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:buy/video:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->

<!--        </a-space>-->
        <table-setting
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 详情 -->
      <detail-form ref="detailForm" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.detailForm.handleDetail(record)" v-hasPermi="['user:buy/video:edit']">
            <a-icon type="eye" />详情
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['user:buy/video:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['user:buy/video:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBuyVideo,listBuyVideo, delBuyVideo } from '@/api/user/buyVideo'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/DetailForm'
import { tableMixin } from '@/store/table-mixin'
import { listVideo } from '@/api/video/video'

export default {
  name: 'BuyVideo',
  components: {
    CreateForm,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用?      single: true,
      // 非多个禁用?      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        videoId: null,
        gatherId: null,
        type: null,
        price: null,
        pageNum: 1,
        pageSize: 10
      },
      listAll:[],

      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '序号',
          dataIndex: 'index',
          customRender: (text, record, index) => index + 1,
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: '短剧名称',
          dataIndex: 'videoName',
          width: '10%',
          ellipsis: false,
          align: 'center'
        },

        {
          title: '订单号',
          dataIndex: 'orderNo',
          width: '20%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: '剧集',
          dataIndex: 'serialNumber',
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: '购买类型',
          dataIndex: 'type',
          width: '10%',
          ellipsis: false,
          align: 'center',
          customRender: function (t, r, index) {
            if(t == 0) {
              return '免费'
            }else if(t == 1) {
              return '金币'
            }else if(t == 2) {
              return '金币'
            }else if(t == 3) {
              return '观看广告'
            }
          }
        },
        {
          title: '花费金额',
          dataIndex: 'price',
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: '20%',
          ellipsis: false,
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   // ellipsis: true,,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          ellipsis: false,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getGather();

  },
  computed: {
  },
  watch: {
  },
  methods: {
    getGather() {
      listVideo().then(res => {
        this.listAll = res.data;
      })
    },
    /** 查询用户购买剧集记录列表 */
    getList () {
      this.loading = true
     pageBuyVideo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        videoId: undefined,
        gatherId: undefined,
        type: undefined,
        price: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          return delCancel(ids)
            .then(() => {
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/user-buy-video/export', {
            ...that.queryParam
          }, `用户购买剧集记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/table-responsive.less';
</style>
